import { createDecagonClient } from '@user-portal/chatbot';

export const decagonClient = createDecagonClient({
    projectId: 'walking',
    source: 'web-cabinet',
    env: import.meta.env.ENV === 'prod' ? 'prod' : 'stage',
});
